var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEarnPassive(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 47.167,
    height: 51.981,
    viewBox: "0 0 47.167 51.981",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "noun-money-bag-6317725",
    transform: "translate(-12.5 -9.011)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_1283",
    "data-name": "Grupo 1283"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Caminho_739",
    "data-name": "Caminho 739",
    d: "M44.824,46.37a5.241,5.241,0,1,0,0,10.481h2.62a2.62,2.62,0,0,1,0,5.241H40.894a1.31,1.31,0,1,0,0,2.62h3.931v1.31a1.31,1.31,0,1,0,2.62,0v-1.31a5.241,5.241,0,1,0,0-10.481h-2.62a2.62,2.62,0,1,1,0-5.241h6.551a1.31,1.31,0,1,0,0-2.62H47.444V45.06a1.31,1.31,0,1,0-2.62,0Z",
    transform: "translate(-10.051 -12.892)",
    fill: "#ccff1c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_740",
    "data-name": "Caminho 740",
    d: "M27.778,19.581l-2.056-2.467a3.666,3.666,0,0,1,.93-5.491,18.331,18.331,0,0,1,18.863,0,3.666,3.666,0,0,1,.93,5.491l-2.056,2.467a5.718,5.718,0,0,1,2.176,3.852,2.206,2.206,0,0,1-.431,1.344c8,5.04,13.533,15.255,13.533,23.113,0,10.854-10.559,13.1-23.583,13.1S12.5,58.744,12.5,47.89c0-7.858,5.535-18.073,13.533-23.113a2.206,2.206,0,0,1-.431-1.344A5.718,5.718,0,0,1,27.778,19.581Zm2.141-1.524a12.595,12.595,0,0,1,12.329,0l2.184-2.621a1.046,1.046,0,0,0-.265-1.566A15.711,15.711,0,0,0,28,13.87a1.046,1.046,0,0,0-.265,1.566Zm-1.427,5.375a2.1,2.1,0,0,1-.246-.134,2.484,2.484,0,0,1,.355-.718,6.721,6.721,0,0,1,1.615-1.61,9.988,9.988,0,0,1,11.732,0,6.721,6.721,0,0,1,1.615,1.61,2.484,2.484,0,0,1,.355.718,2.1,2.1,0,0,1-.246.134,17.372,17.372,0,0,0-15.182,0Zm7.591.874c-5.456,0-10.678,3.239-14.651,8.075S15.12,43.206,15.12,47.89a8.791,8.791,0,0,0,1.393,5.142,9.21,9.21,0,0,0,3.969,3.089c3.724,1.674,9.134,2.25,15.6,2.25s11.878-.576,15.6-2.25a9.21,9.21,0,0,0,3.969-3.089,8.791,8.791,0,0,0,1.393-5.142c0-4.684-2.333-10.666-6.312-15.509S41.54,24.307,36.083,24.307Z",
    fill: "#ccff1c",
    fillRule: "evenodd"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEarnPassive);
export default __webpack_public_path__ + "static/media/earn-passive.3fc5edface7ecf3dd80fbb40c1554798.svg";
export { ForwardRef as ReactComponent };